import { createFileRoute } from '@tanstack/react-router'
import { VehicleContentQrPage } from 'pages/app/vehicle-content-qr/VehicleContentQrPage'

export const Route = createFileRoute('/vehicle-content-qr/$id')({
  component: VehicleContentQrPage,
})
